// utils/router.js
import router from '@/router' // 引入路由实例

/**
 * 公共跳转方法
 * @param {string|object} target - 跳转目标：路径字符串（如 '/home'）或路由对象（如 { name: 'user', params: { id: 1 } }）
 * @param {object} [query] - 可选，查询参数（仅当 target 为字符串时有效）
 * @param {boolean} [replace=false] - 是否使用 replace 模式（不留下历史记录）
 * @returns {Promise} 路由跳转的 Promise
 */
export function goTo(target, query = {}, replace = false) {
  let route = target

  // 如果 target 是字符串，则构造路由对象
  if (typeof target === 'string') {
    route = {
      path: target,
      query
    }
  }

  const method = replace ? 'replace' : 'push'
  return router[method](route).catch(err => {
    // 捕获重复跳转等错误（避免控制台报错）
    if (err.name !== 'NavigationDuplicated') {
      console.error('路由跳转失败:', err)
    }
  })
}

/**
 * 替换当前页面（无历史记录）
 * @param {string|object} target
 * @param {object} query
 */
export function goToReplace(target, query = {}) {
  return goTo(target, query, true)
}

/**
 * 打开外部链接（新窗口）
 * @param {string} url
 */
export function openExternal(url) {
  window.open(url, '_blank')
}